/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitReserveCreatePathOrgUnitId, OrgUnitReserveCreateData, OrgUnitReserveCreateStatus201 } from "../types/OrgUnitReserveCreate.ts";

function getOrgUnitReserveCreateUrl(org_unit_id: OrgUnitReserveCreatePathOrgUnitId) {
	const res = { method: "POST", url: `/api/org_unit/${org_unit_id}/reserve/` as const };

	return res;
}

/**
 * @summary создание брони стола
 * {@link /api/org_unit/:org_unit_id/reserve/}
 */
export async function orgUnitReserveCreate(
	org_unit_id: OrgUnitReserveCreatePathOrgUnitId,
	data: OrgUnitReserveCreateData,
	config: Partial<RequestConfig<OrgUnitReserveCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<OrgUnitReserveCreateStatus201, ResponseErrorConfig<Error>, OrgUnitReserveCreateData>({
		method: "POST",
		url: getOrgUnitReserveCreateUrl(org_unit_id).url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
